<template>
  <div>
    <div class="card">
      <div class="card-header">
        <h3>{{ phase }} Phase</h3>
      </div>
      <div class="card-body">
        <validation-observer ref="simpleRules">
          <b-form>
            <b-row>
              <b-col md="6">
                <b-form-group>
                  <label for="type">Visit Reports</label>
                  <validation-provider
                      #default="{ errors }"
                      name="visitReport"
                      :rules="customRules"
                  >
                    <a
                        v-if="parentObj5 && parentObj5.visitReport && parentObj5.visitReport.length > 0"
                        target="_blank"
                        @click="showRevisinos()"
                    ><small style=" float: right; color: #c8a45f;">View Old Files?</small>
                    </a>
                    <b-form-file
                        v-model="phaseFive.visitReport"
                        :file-name-formatter="formatNames"
                        accept=".pdf"
                        multiple
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="6">
                <b-form-group>
                  <label for="completionForm">Completion Form</label>
                  <a
                      v-if="parentObj5 && parentObj5.completionForm"
                      :href="parentObj5 && parentObj5.completionForm && parentObj5.completionForm.url "
                      target="_blank"
                  ><small style=" float: right;">View Old File?</small></a>
                  <validation-provider
                      #default="{ errors }"
                      name="completionForm"
                      rules=""
                  >
                    <b-form-file
                        v-model="phaseFive.completionForm"
                        :file-name-formatter="formatNames"
                        accept=".pdf"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col
                  md="12"
                  style="display: flex; justify-content: end;"
              >
                <button
                    id="submit-phase5"
                    type="button"
                    class="btn btn-outline-primary mt-2"
                    @click.prevent="validationForm"
                >
                  <feather-icon
                      icon="Edit2Icon"
                      class="mr-25"
                  />
                  Submit
                </button>
              </b-col>
            </b-row>
            <hr v-if="reportsBool === true" class="mt-2 mb-2"/>
            <b-row>
              <b-col
                  v-if="reportsBool === true"
                  md="12"
              >
                <h4 v-if="reportsBool === true">Old Reports</h4>
                <div class="card bg-light text-dark">
                  <div class="card-body">
                    <b-row
                        v-for="(item, key) in parentObj5.visitReport"
                        class="mb-1 file-card"
                    >
                      <b-col md="8">
                        <a
                            v-if="item && item.url"
                            :href="item && item.url"
                            target="_blank"
                            style="color: unset;"
                        >
                          {{ item.name }}.pdf</a>
                      </b-col>
                      <b-col
                          md="4"
                          class="align-end cursor-pointer"
                      >
                        <feather-icon
                            icon="XIcon"
                            size="16"
                            @click="deleteFile(item.id)"
                        />
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </validation-observer>
      </div>
    </div>
  </div>
</template>
<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import vSelect from 'vue-select'

import {
  BFormInput, BFormGroup, BForm, BRow, BCol, BFormDatepicker, BFormFile,
} from 'bootstrap-vue'
import {
  required, email, confirmed, password,
} from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { codeBasic } from './code'
import designTypesService from '@/services/settings/designTypesService'
import phaseFiveService from '@/services/project/phaseFiveService'
import phaseTwoService from '@/services/project/phaseTwoService'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    vSelect,
    BFormFile,
    BFormDatepicker,
    BFormInput,
    BFormGroup,
    BForm,
    BRow,
    BCol,
  },
  props: ['phase', 'parentObj5'],
  data() {
    return {
      customRules: 'required',
      reportsBool: false,
      designTypes: [],
      loading: false,
      projectTypes: [],
      projectTypesTemp: [],
      projectStatus: [],
      projectStatusTemp: [],
      phaseFive: {
        visitReport: [],
        completionForm: null,
      },
      required,
      password,
      email,
      confirmed,
    }
  },
  mounted() {
    this.$watch(() => this.tab, val => {
      this.choosenTab = val
    })
    this.$watch(() => this.parentObj5, parentObj => {
      if (parentObj !== null) {
        this.phaseFive = {
          visitReport: [],
          completionForm: null,

        }
      }
    })
  },
  methods: {
    showRevisinos() {
      if (this.reportsBool === false) {
        this.reportsBool = true
      } else {
        this.reportsBool = false
      }
    },
    formatNames(files) {
      if (files.length === 1) {
        return files[0].name
      }
      return `${files.length} files selected`
    },
    validationForm() {
      document.getElementById('submit-phase5').setAttribute('disabled', 'disabled')
      this.loading = true
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          phaseFiveService.post(this.$route.params.id, this.phaseFive)
              .then(response => {
                if (response && response.status === 200) {
                  this.$toast({
                    component: ToastificationContent,
                    position: 'top-right',
                    props: {
                      title: 'Success',
                      icon: 'CheckIcon',
                      variant: 'success',
                      text: 'Phase Five Is Updated Successfully !',
                    },
                  })
                  setTimeout(function(){
                    document.getElementById('submit-phase5').removeAttribute('disabled')
                  }, 5000);
                  this.customRules = ''

                }

                this.loading = false
                this.$emit('refreshPanel', 'true')
                // this.refreshDropzone()
              })
        }
        else{
          document.getElementById('submit-phase5').removeAttribute('disabled')
        }
      }).catch(error => {
        Promise.reject(error)
        setTimeout(function(){
          document.getElementById('submit-phase5').removeAttribute('disabled')
        }, 5000);
      })
    },
    deleteFile(id) {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          phaseFiveService.delete(id).then(response => {
            if (response && response.status === 200) {
              this.$swal({
                icon: 'success',
                title: 'Deleted!',
                text: 'Your Items have been deleted.',
                customClass: {
                  confirmButton: 'btn btn-success',
                },
              }).then(() => {
                this.$emit('refreshPanel', 'true')
                this.loading = false
                document.getElementById('submit-phase5').removeAttribute('disabled')
              })
            }
          })
        } else if (result.dismiss === 'cancel') {
          this.$swal({
            title: 'Cancelled',
            text: '',
            icon: 'error',
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
          this.loading = false
        } else {
          this.loading = false
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';
</style>
